import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CenterService } from 'src/app/private/services/center.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-center',
  templateUrl: './create-center.component.html',
  styleUrl: './create-center.component.scss',
  imports: [SharedModule]
})
export class CreateCenterComponent {

  @Input() type = 'Create'; // Create or Update
  @Input() centerDataToEdit: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() clientId: string = '';

  isLoading = false;
  submitted = false;
  centerForm: FormGroup;

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  constructor(
    private fb: FormBuilder,
    private centerService: CenterService,
    private messageService: MessageService
  ) {
    this.centerForm = this.fb.group({
      center_name: ['', Validators.required],
      bot_client_id: [''],
      client_id: [this.clientId],
      status: ['', Validators.required]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.centerDataToEdit) {
      this.centerForm.patchValue(this.centerDataToEdit);
      this.centerForm.patchValue({
        status: this.centerDataToEdit.status === 1 ? 'Active' : 'Inactive'
      });
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;
    if (this.centerForm.invalid) {
      this.centerForm.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.centerForm.value,
      client_id: this.clientId,
      status : this.centerForm.value.status == 'Active' ? 1 : 0
    }
    this.isLoading = true;

    if (this.type === 'Update') {
      payload.center_id = this.centerDataToEdit.center_id;
      this.centerService.updateCenter(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Center updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Failed to update center!' });
        },
        complete: () => (this.isLoading = false)
      });
    } else {
      this.centerService.createCenter(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Center created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Failed to create center!' });
        },
        complete: () => (this.isLoading = false)
      });
    }
  }
}
